import SuperTokens from "supertokens-auth-react";
import Session from "supertokens-auth-react/recipe/session";
import ThirdParty, { Google, Facebook } from "supertokens-auth-react/recipe/thirdparty";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import EmailVerification from "supertokens-auth-react/recipe/emailverification";
import axios from "axios"; // Import axios

const SUPERTOKENS_COOKIE_DOMAIN = process.env.REACT_APP_SUPERTOKENS_COOKIE_DOMAIN || undefined;
const SUPERTOKENS_COOKIE_SECURE = process.env.REACT_APP_SUPERTOKENS_COOKIE_SECURE === 'true';
const SUPERTOKENS_COOKIE_SAME_SITE = process.env.REACT_APP_SUPERTOKENS_COOKIE_SAME_SITE;

if (process.env.NODE_ENV === 'development') {
  console.log("Initializing SuperTokens (USA Branch). API Domain:", process.env.REACT_APP_API_DOMAIN);
}

const WEBSITE_DOMAIN = process.env.REACT_APP_WEBSITE_DOMAIN || "https://yourshirt.co";

SuperTokens.init({
  style: `
    [data-supertokens~="superTokensBranding"] {
        display: none;
    }
    [data-supertokens~="container"] {
      --palette-primary: 23, 23, 23;
      --palette-primaryBorder: 38, 38, 38;
      --palette-buttonText: 255, 255, 255;
    }
    [data-supertokens~="button"] {
      background-color: #171717;
      border-color: #262626;
    }
  `,
  getRedirectionURL: async (context) => {
    if (context.action === "SUCCESS") {
      const path = context.redirectToPath ?? "/";
      const base = WEBSITE_DOMAIN.replace(/\/$/, "");
      const pathStr = path.startsWith("/") ? path : `/${path}`;
      return `${base}${pathStr}`;
    }
    return undefined;
  },
  appInfo: {
    appName: "TShirtApp",
    // USA (yourshirt.co): api/auth at api.yourshirt.co, sign-in/up & callback at yourshirt.co/auth
    apiDomain: process.env.REACT_APP_API_DOMAIN || (process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_LOCAL_API_DOMAIN
      : "https://api.yourshirt.co"),
    websiteDomain: WEBSITE_DOMAIN,
    apiBasePath: "/auth",
    websiteBasePath: "/auth",
  },
  recipeList: [
    EmailVerification.init({
      mode: "REQUIRED",
    }),
    ThirdParty.init({
      signInAndUpFeature: {
        providers: [
          Google.init(),
          Facebook.init(),
        ],
      },
    }),
    EmailPassword.init({
      signInAndUpFeature: {
        signUpForm: {
          formFields: [
            {
              id: "name",
              label: "Full Name",
              placeholder: "Enter your full name",
              validate: async (value) => value.length === 0 ? "Full Name is required" : undefined,
            },
          ],
        },
      },
    }),
    Session.init({
      cookieDomain: SUPERTOKENS_COOKIE_DOMAIN,
      cookieSecure: SUPERTOKENS_COOKIE_SECURE,
      cookieSameSite: SUPERTOKENS_COOKIE_SAME_SITE,
      axios: axios, // Pass the axios instance here
    }),
  ],
});
